import React, { useState, useEffect } from "react";
import { Text, View, Button, ScrollView, Platform, Image } from "react-native";
import { useMsal } from "./auth/MsalProvider";
import LHLoader from "./LHLoader";

const MsalProfile = () => {
  const { signIn, account, accessToken } = useMsal();
  const [isLoading, setIsLoading] = useState(true);
  const [selectedHoursType, setSelectedHoursType] = useState<'schedule' | 'actual'>('schedule');

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  console.log("Account:", account);
  console.log("Access Token:", accessToken);

  if (isLoading) {
    return <LHLoader />;
  }

  return (
    <ScrollView
      contentContainerStyle={{
        padding: 24,
        flexGrow: 1,
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {account ? (
        <>
          <Text>👤 Signed in as:</Text>
          <Text style={{ marginVertical: 10 }}>
            {account.username || account.name}
          </Text>

          {/* <Button title="Get Access Token" onPress={acquireTokenSilent} /> */}
          {/*
          {accessToken && (
            <>
              <Text style={{ marginTop: 20 }}>🔑 Access Token:</Text>
              <Text selectable style={{ fontSize: 12, color: "#333" }}>
                {accessToken}
              </Text>
            </>
          )} */}
          {/*
          <View style={{ marginTop: 20 }}>
            <Button title="Sign Out" color="red" onPress={signOut} />
          </View> */}
        </>
      ) : (
        <>
          <View
            style={{
              alignItems: "center",
              justifyContent: "center",
              marginBottom: 50,
              width: "100%",
            }}
          >
            <Image
              source={require("../assets/warehouse_navigator.png")}
              style={{
                height: 120,
                width: 120,
                marginBottom: 30,
              }}
              resizeMode="contain"
            />
            <Text
              style={{
                fontSize: 24,
                marginBottom: 40,
                textAlign: "center",
              }}
            >
              Microsoft Entra ID Login
            </Text>
          </View>
          <View
            style={{
              width: "100%",
              alignItems: "center",
              paddingHorizontal: 20,
            }}
          >
            <Button title="Sign In with Microsoft" onPress={signIn} />
          </View>
        </>
      )}

      <Text
        style={{
          marginTop: 40,
          fontSize: 12,
          color: "#666",
          textAlign: "center",
          position: "absolute",
          bottom: 20,
        }}
      >
        Platform: {Platform.OS}
      </Text>
    </ScrollView>
  );
};

export default MsalProfile;
